import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReduceCapacityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reduce_capacity"}/>
}
